import React from "react";
import classNames from "classnames";
import "./style.scss";
type Props = {
  className?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  value: boolean;
  onChange: (value: boolean) => void;
};
export const Checkbox: React.FC<Props> = ({
  className,
  children,
  disabled = false,
  value = false,
  onChange = () => {},
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };
  return (
    <label className={classNames("checkbox", className)}>
      {children}
      <input
        type="checkbox"
        checked={value}
        onChange={handleChange}
        disabled={disabled}
      />
      <span></span>
    </label>
  );
};
